import styled from 'styled-components';
import { cssSpacing } from '@spotify-internal/encore-web';
import { ApprovalStatus } from '@hooks/useAlbumInfo/types';
import { useApprovalStatusCopy } from '@hooks/useApprovalStatusCopy';
import { useProfileProtectionsCopy } from '@hooks/useProfileProtectionsCopy';
import { FilterItem } from '@helpers/filterItem';
import { FilterDropdown } from '@components/shared/FilterDropdown';

const FilterContainer = styled.div`
  margin-bottom: ${cssSpacing('base')};
`;

interface ApprovalStatusFilterProps {
  selectedStatuses: ApprovalStatus[];
  onApply: (selectedStatuses: ApprovalStatus[]) => void;
}

const FILTER_ITEMS: ApprovalStatus[] = [
  ApprovalStatus.APPROVED,
  ApprovalStatus.DECLINED,
  ApprovalStatus.PARTIALLY_APPROVED,
  ApprovalStatus.NEEDS_APPROVAL,
  ApprovalStatus.EXPIRED,
  ApprovalStatus.NO_APPROVAL_NEEDED,
];

export const ApprovalStatusFilter = ({
  selectedStatuses,
  onApply,
}: ApprovalStatusFilterProps) => {
  const copy = useApprovalStatusCopy();
  const protectionsCopy = useProfileProtectionsCopy();

  const labelMap: Record<string, string> = {
    [ApprovalStatus.APPROVED]: copy.approved,
    [ApprovalStatus.DECLINED]: copy.declined,
    [ApprovalStatus.PARTIALLY_APPROVED]: copy.partiallyApproved,
    [ApprovalStatus.NEEDS_APPROVAL]: copy.needsApproval,
    [ApprovalStatus.EXPIRED]: copy.expired,
    [ApprovalStatus.NO_APPROVAL_NEEDED]: copy.noApprovalNeeded,
  };

  const filterItems: FilterItem[] = FILTER_ITEMS.map(status => ({
    id: status,
    label: labelMap[status],
  }));

  return (
    <FilterContainer>
      <FilterDropdown
        label={protectionsCopy.approvalStatus}
        aria-label={protectionsCopy.filterByApprovalStatus}
        name="filter-by-approval-status"
        items={filterItems}
        selectedValues={selectedStatuses as string[]}
        onApply={values => onApply(values as ApprovalStatus[])}
        helpText={protectionsCopy.filterHelpText}
      />
    </FilterContainer>
  );
};
